// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2qwo_","alert":"SettungsInbox_alert__Q7D_P"};